import { RecipeType } from "@/lib/types";
import { PlusIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router";

interface NoResultsProps {
    hasNoResultsWithFilters: boolean;
    recipeType?: RecipeType;
}

export const NoResults = ({ hasNoResultsWithFilters, recipeType }: NoResultsProps) => {
    const recipeTypeSegment = recipeType ? ` "${recipeType}" ` : " ";
    const noSearchResultsMessageSegments = ["No", recipeTypeSegment, "recipes found that match your search criteria."];
    const noRecipeMessageSegments = ["You have no", recipeTypeSegment, "recipes yet. Start by adding a new recipe."];

    const message = hasNoResultsWithFilters
        ? noSearchResultsMessageSegments.join("")
        : noRecipeMessageSegments.join("");

    const showAddRecipeButton = !hasNoResultsWithFilters;

    return (
        <div className="mt-20 mb-120">
            <p className="text-center text-3xl">{message}</p>
            <div className="w-full text-center py-6">
                {showAddRecipeButton && (
                    <Link
                        className="mx-auto inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-primary-500 text-white hover:bg-primary-600 transition-colors"
                        to="/recipes/new"
                    >
                        <PlusIcon className="w-4 h-4" />
                        Add Recipe
                    </Link>
                )}
            </div>
        </div>
    );
};
